import { Layout, Card } from 'antd';
import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <Layout
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f3f4f6',
      }}
    >
      <Card
        style={{
          width: 420,
          boxShadow: '0 4px 12px rgba(0,0,0,0.10), 0 2px 4px rgba(0,0,0,0.06)',
        }}
      >
        <Outlet />
      </Card>
    </Layout>
  );
}
